// extracted by mini-css-extract-plugin
module.exports = {"documentPreview":"styles_documentPreview__XezbD"};